import { handleResponseError } from "helpers/utils"
import { API } from "./endpoint"
import httpClient from "../axios/interceptors"
import { AxiosResponse } from "axios"
import { ApprovePointInput, ApprovePointResponse, GetRequireApprovePointInput, GetRequireApprovePointResponse } from "./interface"



//factory/points/find_all
export const getRequireApprovePoint = async (
  input: GetRequireApprovePointInput
): Promise<GetRequireApprovePointResponse> => {
  const data: AxiosResponse<GetRequireApprovePointResponse> = await httpClient
    .post(API.getRequireApprovePoint, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

//factory/points/approve
export const approveRequireApprovePoint = async (
  input: ApprovePointInput
): Promise<ApprovePointResponse> => {
  const data: AxiosResponse<ApprovePointResponse> = await httpClient
    .post(API.approveRequireApprovePoint, input)
    .catch((error) => handleResponseError(error))
  return data.data
}
